import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import {
    normalizeStatusMessages,
    resolveIntervalMs,
    shouldUseAgencyLogo,
    startStatusRotation
} from './loadingIconFullHelpers'
import { animateGenerationMark } from './loadingIconFullMotion'
import LoadingIcons from './loadingIcon1'

function TranspondMark({ markRef }) {
    return (
        <svg
            ref={markRef}
            className='loadingIconFull__mark'
            xmlns='http://www.w3.org/2000/svg'
            width='56'
            height='64'
            viewBox='2 0 27.772 32'
            fill='currentColor'
            aria-hidden='true'
            focusable='false'
        >
            <g className='loadingIconFull__band loadingIconFull__band--top'>
                <path d='M11.251 2.66667L6.61659 5.33333L2 2.66667L6.61659 0L11.251 2.66667Z' />
                <path d='M15.8862 5.33332L11.2518 7.99999L6.61737 5.33332L11.2518 2.66666L15.8862 5.33332Z' />
                <path d='M20.5201 8.00001L15.8857 10.6667L11.2513 8.00001L15.8857 5.33334L20.5201 8.00001Z' />
                <path d='M25.154 10.6667L20.5195 13.3333L15.8851 10.6667L20.5195 8L25.154 10.6667Z' />
                <path d='M29.7702 13.3333L25.1536 16L20.5192 13.3333L25.1536 10.6667L29.7702 13.3333Z' />
                <path d='M29.7711 13.3333V18.6667L25.1545 21.3333V16L29.7711 13.3333Z' />
                <path d='M6.61659 0V5.33333L2 8V2.66667L6.61659 0Z' />
            </g>
            <g className='loadingIconFull__band loadingIconFull__band--middle'>
                <path d='M20.5195 18.6667V24L15.8851 26.6667V21.3333L20.5195 18.6667Z' />
                <path d='M11.251 13.3333L6.61659 16L2 13.3333L6.61659 10.6667L11.251 13.3333Z' />
                <path d='M15.8862 16L11.2518 18.6667L6.61737 16L11.2518 13.3333L15.8862 16Z' />
                <path d='M20.5201 18.6667L15.8857 21.3333L11.2513 18.6667L15.8857 16L20.5201 18.6667Z' />
                <path d='M6.61659 10.6667V16L2 18.6667V13.3333L6.61659 10.6667Z' />
            </g>
            <g className='loadingIconFull__band loadingIconFull__band--bottom'>
                <path d='M11.2518 24V29.3333L6.61737 32V26.6667L11.2518 24Z' />
                <path d='M11.251 24L6.61659 26.6667L2 24L6.61659 21.3333L11.251 24Z' />
                <path d='M6.61659 21.3333V26.6667L2 29.3333V24L6.61659 21.3333Z' />
            </g>
        </svg>
    )
}

export default function LoadingIconFull({ bottomText, changingText, intervalMs, className = '', style }) {
    const siteMaster = useSelector((state) => state.siteMaster)
    const useAgencyLogo = shouldUseAgencyLogo(siteMaster)
    const markRef = useRef(null)
    const messages = useMemo(() => normalizeStatusMessages(changingText), [changingText])
    const messagesKey = messages.join('\u0001')
    const resolvedInterval = resolveIntervalMs(intervalMs)
    const [statusIndex, setStatusIndex] = useState(0)

    useEffect(() => {
        setStatusIndex(0)
        return startStatusRotation({
            messages,
            intervalMs: resolvedInterval,
            onChange: setStatusIndex
        })
    }, [messagesKey, resolvedInterval])

    useEffect(() => {
        if (useAgencyLogo) return undefined
        return animateGenerationMark(markRef.current)
    }, [useAgencyLogo])

    const hint = typeof bottomText === 'string' && bottomText.trim().length > 0 ? bottomText.trim() : ''
    const statusText = messages[statusIndex] || messages[0] || ''
    const rootClass = ['loadingIconFull', className].filter(Boolean).join(' ')

    return (
        <div className={rootClass} style={style}>
            {useAgencyLogo ? <LoadingIcons /> : <TranspondMark markRef={markRef} />}
            {!!statusText && (
                <p className='loadingIconFull__status' role='status' aria-live='polite' aria-atomic='true'>
                    <span className='loadingIconFull__text'>
                        {statusText}
                        <span className='loadingIconFull__shine' data-text={statusText} aria-hidden='true' />
                    </span>
                </p>
            )}
            {!!hint && <p className='loadingIconFull__hint'>{hint}</p>}
        </div>
    )
}
